






























import { DocumentIdModel, OnlineViewModel } from "@/model/document/documentModel";
import { JournalOnlineViewModel } from "@/model/document/journalDocumentModal";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreAlert = namespace("Alert");
const StoreDocument = namespace("Document");

@Component
export default class ModalRemovePassCode extends Vue {
  @Prop({ default: 0 }) sourceType!: number;
  @Prop({ default: "" }) documentName!: string;
  @Prop({ default: "" }) transactionNumber!: string;
  @Prop({ default: false }) isDocumentNameShort!: boolean;

  private showModal = true;

  @StoreDocument.Getter
  private getDocumentDetail!: OnlineViewModel | JournalOnlineViewModel | null;
  @StoreDocument.Action
  private DoRemoveOnlineViewPassCode!: (input: DocumentIdModel) => void;

  @Watch("showModal")
  showModalChanged() {
    if (!this.showModal) {
      this.HideModal();
    }
  }

  public HideModal() {
    this.$emit("update:showModal", false);
  }
  public RemovePassCode() {
    if (this.getDocumentDetail) {
      let input = {
        transactionType: this.getDocumentDetail.transactionType,
        financeType: this.getDocumentDetail.financeType,
        transactionId: this.getDocumentDetail.transactionId,
        sourceType: this.sourceType,
        documentName: this.documentName,
        transactionNumber: this.transactionNumber,
        isDocumentNameShort: this.isDocumentNameShort,
      };
      this.DoRemoveOnlineViewPassCode(input);
      this.HideModal();
    }
  }
}
